module.exports = __webpack_public_path__ + "static/assets/3d607a5115b397bb2f5b667440131c21.svg";